import { IonContent, IonIcon, IonItem, IonLabel, IonList, IonRefresher, IonRefresherContent, IonSpinner, IonThumbnail } from "@ionic/react";
import { useQuery } from "@tanstack/react-query";
import { t } from "i18next";
import moment from "moment";
import React, { useContext, useState } from "react";
import { config } from "../../app.config";
import { BasicTemplate } from "../../components/PageTemplates";
import { AuthenticatedUserContext } from "../../contexts/AuthenticatedUserContext";
import { ApiService } from "../../services";
import { folderOutline } from "ionicons/icons";

const FileItem = (props: any) => {
  const [fileWasOpened, setFileWasOpened] = useState<boolean>(false);
  const { numUnreadFiles, setNumUnreadFiles } = useContext(AuthenticatedUserContext);

  const openFile = () => {
    ApiService.get("members/me/files/" + props.file.id);
    setFileWasOpened(true);

    if (!props.file.read) {
      setNumUnreadFiles(numUnreadFiles - 1);
    }
  };

  return (
    <IonItem
      button={true}
      onClick={() => {
        openFile();
        window.open(props.file.url);
      }}
    >
      <IonThumbnail
        style={{
          "--border-radius": "100%",
        }}
        slot={"start"}
      >
        <img alt={props.file.name} src={props.file.thumbnail} />
      </IonThumbnail>

      <IonLabel
        style={{
          fontWeight: props.file.read || fileWasOpened ? "normal" : "bold",
        }}
      >
        {props.file.name}
        <p>{moment(props.file.updated_at).format(config.format.dateTime)}</p>
      </IonLabel>
    </IonItem>
  );
};

export const MyFiles = (props: any) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["my-files"],
    queryFn: async () => {
      return await ApiService.get("members/me/files");
    },
  });

  return (
    <BasicTemplate hideHeader={false} title={t("myFiles") || ""} hideBackButton={false}>
      <IonContent fullscreen={true} class={"ion-padding"} color={"light"}>
        <IonRefresher
          slot={"fixed"}
          onIonRefresh={(event) => {
            refetch().then(event.detail.complete);
          }}
        >
          <IonRefresherContent></IonRefresherContent>
        </IonRefresher>

        {isLoading ? (
          <IonSpinner name={"dots"} className={"block ion-text-center ion-margin-top"} />
        ) : (
          data?.data?.length === 0 ? <div>
            <div>
              <IonIcon icon={folderOutline} size={"large"} />
            </div>
            <IonLabel className={"ion-text-wrap ion-block ion-margin-top"}>{t("noFiles")}</IonLabel>
          </div> : <IonList inset={true}>{data?.data?.map((file: any) => <FileItem file={file} key={`file-${file.id}`} />)}</IonList>
        )}
      </IonContent>
    </BasicTemplate>
  );
};
